
<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
  metaInfo: {
      title: 'Fernando Mata',
      titleTemplate: '%s - iOS & Swift Developer'
  },
  components: {
  }
}
</script>

<style lang="scss">
  @import "./assets/css/main.css";
</style>
